import type { QuestionType } from '@repo/types/enums/questionType';
import type { ComponentProps, ReactNode } from 'react';

import { cn } from '@repo/lib/cn';
import { CircleAlertIcon } from 'lucide-react';

import { Separator } from '@/components/ui/separator';
import { Tiptap } from '@/components/ui/tiptap-editor';
import { questionsLabel } from '@/lib/questions-labels';
import { quizExtensionSet } from '@/lib/tiptap-extensions-sets';

interface QuestionBaseProps extends ComponentProps<'div'> {
  content: string;
  children: ReactNode;
  type: QuestionType;
}

export function QuestionBase(questionBaseProps: QuestionBaseProps) {
  const { content, children, type, className, ...props } = questionBaseProps;

  const desc: string = questionsLabel[type].desc;

  return (
    <div className={cn('space-y-6', className)} {...props}>
      <div className="bg-surface-secondary-hover/70 border-border-secondary rounded-md border p-3">
        <Tiptap extensions={quizExtensionSet} editable={false} content={content} />
      </div>
      <Separator className="bg-border-secondary" />
      <div className="text-text-tertiary flex items-center gap-1 text-sm">
        <CircleAlertIcon className="size-3.5" />
        <span> {desc}</span>
      </div>
      <div className="flex flex-col gap-4">{children}</div>
    </div>
  );
}
